/** Shared look of approval states across the inbox, the group tab and the calendar. */
export const APPROVAL_STYLES = {
  proposed:  { bg: "rgba(247,204,83,0.18)", color: "#8a5a00", label: "Waiting for approval" },
  approved:  { bg: "rgba(15,123,134,0.12)", color: "#0b5f68", label: "Approved" },
  rejected:  { bg: "rgba(243,78,78,0.10)",  color: "#b8402d", label: "Rejected" },
  cancelled: { bg: "#f5f6f8",               color: "#74788d", label: "Cancelled" },
};

export const ApprovalBadge = ({ status, title }) => {
  const s = APPROVAL_STYLES[status] ?? APPROVAL_STYLES.cancelled;
  return (
    <span title={title || undefined} style={{
      display: "inline-block", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20,
      background: s.bg, color: s.color, letterSpacing: "0.3px", whiteSpace: "nowrap",
    }}>
      {s.label}
    </span>
  );
};

export const personName = (p) => (p?.name && p.name.trim()) || p?.username || "";
